<template>
  <Navbar/>
  <div class="p-4">
    <div class="d-flex mb-4 text-darker justify-content-evenly">
      <a href="#" class="text-secondary text-decoration-none">
        <i class="fas fa-search"></i> Szukaj
      </a>
      <a href="#" class="text-primary text-decoration-none">
        <i class="fas fa-sync"></i> Odśwież
      </a>
    </div>
    <hr>
    <h2 class="text-center">Dodaj nową naczepę</h2>
    <ImportXlsxTrailers/>
    <form @submit.prevent="createTrailer">
      <div class="mb-3">
        <label for="place-name" class="form-label">Nazwa</label>
        <input type="text" class="form-control" id="place-name" v-model="name" required>
      </div>
      <button type="submit" class="btn btn-primary">Zatwierdź</button>
    </form>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Swal from 'sweetalert2'
import ImportXlsxTrailers from '@/pages/Trailers/ImportXlsxTrailers.vue'
export default {
  name: 'CreateTrailer',
  components: { ImportXlsxTrailers, Navbar },
  data () {
    return {
      name: '',
      textColor: '#000000',
      backgroundColor: '#ffffff'
    }
  },
  methods: {
    async createTrailer () {
      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/json')
      myHeaders.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`)

      var raw = JSON.stringify({
        name: this.name,
        plateNumber: this.name
      })

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      }

      fetch(`${process.env.VUE_APP_API_BASE_URL}Trailer`, requestOptions)
        .then(response => response.text())
        .then(result => {
          if (result.includes('already exist')) {
            Swal.fire('Naczepa o tej nazwie już istnieje', '', 'error')
          } else {
            Swal.fire('Naczepa została dodana pomyślnie', '', 'success').then(() => {
              this.$router.push({ name: 'StoreHouseListing' })
            })
          }
        })
        .catch(error => {
          console.log('error', error)
        })
    }
  }
}
</script>
